import React, { useEffect, useState, Fragment } from "react";
import { Container, Row, Col, Modal } from "react-bootstrap";
import { useParams, Link, useNavigate } from 'react-router-dom';
import CurrencyFormat from '../Helpers/Formatters/CurrencyFormat';
import { AddCircleOutlineOutlined as AddCircleOutlineOutlinedIcon } from '@mui/icons-material';
import { Close as CloseIcon } from '@mui/icons-material';
import { IconButton, Card, CardContent, Typography, Box, LinearProgress, Button, CircularProgress, Chip, SvgIcon } from '@mui/material';
import CustomerSupportPhone from './CustomerSupportPhone';
import { SESSION_STORAGE_ACCOUNT_KEY, SESSION_STORAGE_COVR_FULLUW_KEY, getSessionStorageItem, storeConsumerApplicationId, SESSION_STORAGE_AMERICO_OBJECT_KEY, SESSION_STORAGE_SSO_ACCESS_TOKEN_KEY } from '../../sessionStorage';

import { KeyboardArrowRight as KeyboardArrowRightIcon } from '@mui/icons-material';
import { KeyboardArrowDown as KeyboardArrowDownIcon } from '@mui/icons-material';
import { DesktopWindows as DesktopWindowsIcon } from '@mui/icons-material';
import { Person as PersonIcon } from '@mui/icons-material';
import { Search as SearchIcon } from '@mui/icons-material';
import { Mail as MailIcon } from '@mui/icons-material';
import { BeachAccess as BeachAccessIcon } from '@mui/icons-material';

import IconHolder from "../Helpers/IconHolder";
import CalendarIcon from '../../icons/calendar.svg?react';
import './Account.scss';

export default function Activity(props) {

  const { applicationId } = useParams();
  const [activitySummaryList, setActivitySummaryList] = useState([]);
  const [activeCaseStatus, setActiveCaseStatus] = useState(null);
  const [isCoverageModalOpen, setIsCoverageModalOpen] = useState(false);

  useEffect(() => {
    let activities = null;
    let inProgress = "";
    if (props.caseStatusList) {
      activities = props.caseStatusList.map((caseStatusItem, index) => <ActivitySummary key={index} caseStatus={caseStatusItem} />);
    }
    if (props.inProgressAppsList) {
      inProgress = props.inProgressAppsList.map((item, index) => <InProgressSummary key={index} inProgressItem={item} />);
    }

    if (activities) {
      setActivitySummaryList(
        <React.Fragment>
          {activities && activities.length > 0 &&
            <React.Fragment>
              <Row style={{ "width": "100%", "marginLeft": '0' }}>
                <Col xs={12} lg={12} className="order-1" >
                  Submitted Applications
                </Col>
              </Row>
              {activities}
            </React.Fragment>}
          {inProgress && inProgress.length > 0 &&
            <React.Fragment>
              <Row style={{ "width": "100%", "marginLeft": '0' }} >
                <Col xs={12} lg={12} className="order-1" >
                  Uncompleted Applications
                </Col>
              </Row >
              {inProgress}
            </React.Fragment>}
        </React.Fragment>);
    } else {
      setActivitySummaryList(<div className="px-0"><CircularProgress /></div>);
    }

    if (applicationId && props.caseStatusList && props.caseStatusList.length) {
      setActiveCaseStatus(props.caseStatusList.find(cs => cs.ApplicationId === applicationId));
    } else {
      setActiveCaseStatus(null);
    }
  }, [props.caseStatusList, applicationId, props.inProgressAppsList]);

  return <Container>
    {activeCaseStatus ? <ActivityDetails caseStatus={activeCaseStatus} /> :
      <React.Fragment>
        <Row>
          <Col xs={12} className='mb-4'>
            <button onClick={() => { setIsCoverageModalOpen(true) }} className="buttonClass">
              <span className='ms-1 float-end'><b>ADD COVERAGE</b></span>
              <SvgIcon component={AddCircleOutlineOutlinedIcon} className='float-end' color='primary' />
            </button>
          </Col>
        </Row>
        <Row className="activityList">{activitySummaryList}</Row>
        <CoverageDetailDialog
          show={isCoverageModalOpen}
          onHide={() => setIsCoverageModalOpen(false)}
        />
        </React.Fragment>}
  </Container>;
}

const CommonLinearProgress = ({ 
  value, 
  barColor, 
  trackColor = "#E3E3E3", // Default track color
  className = "",
  ...rest
}) => {
  return (
    <LinearProgress
      variant="determinate"
      value={value}
      className={`common-status-progress ${className}`}
      style={{
        '--bar-color': barColor,
        '--track-color': trackColor,
      }}
      {...rest}
    />
  );
};

const CoverageDetailDialog = (props) => {

  const navigate = useNavigate();
  const phoneNumber = CustomerSupportPhone();

  const cardList = [
    {
      icon: CalendarIcon,
      name: "TERM LIFE INSURANCE",
      href: "/landing/etrade-term",
    },
    // {
    //   icon: ShieldIcon,
    //   name: "LOAN PROTECTION",
    //   href: "/landing/loan-protector",
    // },
    // {
    //   icon: CrutchIcon,
    //   name: "DISABILITY INCOME",
    //   href: "/landing/disability-income",
    // },
  ]

  return (
    <Modal {...props} aria-labelledby="Coverage-modal" size="lg" className="coverage-modal">
      <Modal.Body className='p-0'>
        <Container className='p-0'>
          <Row className="g-0 coverage-header">
            <div className='imageForCoverageModal'></div>
            <div class="headerDiv">
              <div className="coverage-text">New Coverage</div>
            </div>
            <Col className="text-end">
              <IconButton
                aria-label="close"
                className="closeButton activity-close-button"
                onClick={props.onHide}
                size="large">
                <CloseIcon />
              </IconButton>
            </Col>
          </Row>
          <Row className='topClass'>
            <Col className='marginClass'>
              <div className='coverage-title'>Certain life events may trigger the need to purchase additional coverage, or even new coverage for a loved one.</div>
              <Row className="mt-3 card-alignment">
                {cardList.map((card, i) => (
                  <Col xs="auto" className="pe-0 pb-3 mt-3" key={i}>
                    <Card className="card-vertical d-flex flex-column" variant="elevation" >
                      <CardContent className='pointerDiv' onClick={() => navigate(card.href)}>
                        <div className="d-flex justify-content-center">
                          <IconHolder icon={card.icon} viewBox="0 0 25 25" />
                        </div>
                        <Typography variant="body1" component="div" align="center" className="mt-2 p-2">
                          <Box
                            sx={{
                              fontWeight: "fontWeightBold",
                              fontSize: 15
                            }}>
                            {card.name}
                          </Box>
                        </Typography>
                      </CardContent>
                    </Card>
                  </Col>
                ))}
              </Row>
              <div class="mb-3 coverage-footer">
                If you need additional coverage AND have an application pending decision, please contact our team directly at &nbsp;
                <a href={`tel:${phoneNumber}`}>
                  {phoneNumber}
                </a>
                .
              </div>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
    </Modal>
  );
};


const ActivitySummary = (props) => {

  return <Row className="policy">
    <Col xs={6} lg={2} md={2} className="order-1">
      <img className="img-fluid" src={props.caseStatus.CarrierLogoUrl} alt="carrierLogoUrl"/>
    </Col>
    <Col xs={6} lg={2} md={3} className="order-2 order-lg-3 priceAmount order-md-3">
      <p className="premium"><CurrencyFormat number={props.caseStatus.Premium} /><span className="perMonth">/mo</span></p>
    </Col>
    <Col xs={12} lg={3} md={3} className="order-3 order-lg-2 order-md-2 carrierTerm">
      <p className="carrierProduct">{props.caseStatus.Product}</p>
      <p className="faceTerm"><CurrencyFormat number={props.caseStatus.FaceAmount} whole /> - {props.caseStatus.TermLength} Year Term</p>
    </Col>
    <Col xs={6} lg={3} md={2} className="order-4">
      <p className="activity-status">{props.caseStatus.Status}</p>
      <CommonLinearProgress 
        value={props.caseStatus.ConsumerDetailStep * 20}
        barColor={props.caseStatus.ConsumerStatusColor}
        myColor="black"
      />
    </Col>
    <Col xs={6} lg={2} md={2} className="order-5 btnView">
      <Button component={Link} to={`/account/activity/${props.caseStatus.ApplicationId}`} variant="contained" color="primary">
        View <Chip label={"1"} size="small" className="background-white ms-1" clickable />
      </Button>

    </Col>
  </Row>
}

const StatusFinished = (props) => {
  return <Fragment>
    <Row className="baseActivityStatus finished">
      <Col className="col-auto">
        {props.icon}

        <KeyboardArrowRightIcon />

        {props.title}
      </Col>

      <Col className="col-auto ms-auto">
        <Chip label={"COMPLETE"} size="small" className="progressChip" />
      </Col>
    </Row>
  </Fragment>
}

const StatusCurrent = (props) => {
  return <Fragment>
    <Row className="baseActivityStatus" style={{backgroundColor: props.caseStatus.ConsumerStatusColor}} >
      <Col className="col-auto">
        {props.icon}

        <KeyboardArrowDownIcon />

        {props.title}
      </Col>
      <Col className="col-auto ms-auto">
        <Chip label={props.caseStatus.ConsumerDetailStep < 5 ? "IN PROGRESS" : "COMPLETE"} size="small" />

      </Col>
    </Row>
    <CurrentStatusInfo caseStatus={props.caseStatus} />
  </Fragment>
}

const StatusFuture = (props) => {
  return <Fragment>
    <Row className="baseActivityStatus finished">
      <Col>
        {props.icon}

        <KeyboardArrowRightIcon />

        <span>{props.title}</span>
      </Col>
    </Row>
  </Fragment>
}

const ActivityDetails = (props) => {

  return (props.caseStatus == null) ? <div className="px-0"><CircularProgress /></div> :
    <div>
      <Link to="/account/activity">Back</Link>

      <Row>
        <Col>
          <img className="img-fluid" src={props.caseStatus.CarrierLogoUrl} alt="carrierLogoUrl" />
        </Col>
        <Col>
          {props.caseStatus.Product} {' '}
          <CurrencyFormat number={props.caseStatus.FaceAmount} whole />
        </Col>
        <Col>
          {<CurrencyFormat number={props.caseStatus.Premium} />}/mo

        </Col>
      </Row>

      <Row className="baseActivityStatus background-white">
        <Col>
          <p>{props.caseStatus.ConsumerPlatformStatusTracker}</p>
          Step {props.caseStatus.ConsumerDetailStep} of 5

          <CommonLinearProgress 
            value={props.caseStatus.ConsumerDetailStep * 20}
            barColor={props.caseStatus.ConsumerStatusColor}
            trackColor={props.caseStatus.ConsumerStatusBackgroundColor}
          />
          {props.caseStatus.ConsumerPlatformStatusTracker}
        </Col>
      </Row>

      {props.caseStatus.ConsumerDetailStep > 1 && <StatusFinished caseStatus={props.caseStatus} title="Quoting Coverage" icon={<DesktopWindowsIcon />} />}
      {props.caseStatus.ConsumerDetailStep === 1 && <StatusCurrent caseStatus={props.caseStatus} title="Quoting Coverage" icon={<DesktopWindowsIcon />} />}

      {props.caseStatus.ConsumerDetailStep > 2 && <StatusFinished caseStatus={props.caseStatus} title="Completing Application" icon={<PersonIcon />} />}
      {props.caseStatus.ConsumerDetailStep === 2 && <StatusCurrent caseStatus={props.caseStatus} title="Completing Application" icon={<PersonIcon />} />}
      {props.caseStatus.ConsumerDetailStep < 2 && <StatusFuture caseStatus={props.caseStatus} title="Completing Application" icon={<PersonIcon />} />}

      {props.caseStatus.ConsumerDetailStep > 3 && <StatusFinished caseStatus={props.caseStatus} title="Application Review" icon={<SearchIcon />} />}
      {props.caseStatus.ConsumerDetailStep === 3 && <StatusCurrent caseStatus={props.caseStatus} title="Application Review" icon={<SearchIcon />} />}
      {props.caseStatus.ConsumerDetailStep < 3 && <StatusFuture caseStatus={props.caseStatus} title="Application Review" icon={<SearchIcon />} />}

      {props.caseStatus.ConsumerDetailStep > 4 && <StatusFinished caseStatus={props.caseStatus} title="Policy Delivery" icon={<MailIcon />} />}
      {props.caseStatus.ConsumerDetailStep === 4 && <StatusCurrent caseStatus={props.caseStatus} title="Policy Delivery" icon={<MailIcon />} />}
      {props.caseStatus.ConsumerDetailStep < 4 && <StatusFuture caseStatus={props.caseStatus} title="Policy Delivery" icon={<MailIcon />} />}

      {props.caseStatus.ConsumerDetailStep === 5 && <StatusCurrent caseStatus={props.caseStatus} title={props.caseStatus.ConsumerPlatformStatusTracker !== "Closed" ? "Coverage Active" : "Coverage Inactive"} icon={<BeachAccessIcon />} />}
      {props.caseStatus.ConsumerDetailStep < 5 && <StatusFuture caseStatus={props.caseStatus} title={props.caseStatus.ConsumerPlatformStatusTracker !== "Closed" ? "Coverage Active" : "Coverage Inactive"} icon={<BeachAccessIcon />} />}

    </div>

}

const CurrentStatusInfo = (props) => {
  return (
    <Row className="currentStatus" style={{backgroundColor: props.caseStatus.ConsumerStatusBackgroundColor, border: `2px solid ${props.caseStatus.ConsumerStatusColor}`}} >
      <Col>
        <p>{props.caseStatus.Status}</p>
        {
          <p>{props.caseStatus.ConsumerWhatsNext}</p>
        }
      </Col>
    </Row>
  )
}

const InProgressSummary = (props) => {

  const navigate = useNavigate();
  //const [loading, setLoading] = useState(false);
  //const [message, setMessage] = useState('');

  const covrServicesUrl = window.__ENV__.REACT_APP_COVR_SERVICES_URL;

  const retrieveProgress = (consumerApplicationId) => {
    fetch(`${covrServicesUrl}/api/ConsumerApplication/SSOGet?AppId=${consumerApplicationId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'SessionId': getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).sessionId,
        'Authorization': 'Bearer ' + getSessionStorageItem(SESSION_STORAGE_SSO_ACCESS_TOKEN_KEY),
      }
    })
      .then(storeConsumerApplicationId)
      .then(data => {
        if (data.appData !== null && data.appData.includes('currentStep')) {
          const jsonRes = JSON.parse(data.appData);
          if(jsonRes.steps && jsonRes.steps.quoter.product === 'Americo'){
            const SESSION_STORAGE_KEY = "AMERICO_QUOTE";
            sessionStorage.setItem(SESSION_STORAGE_KEY, data.appData);
            jsonRes.mctFlowData ? sessionStorage.setItem(SESSION_STORAGE_COVR_FULLUW_KEY,JSON.stringify(jsonRes.mctFlowData)) : null;
            jsonRes.mctQuoterData ? sessionStorage.setItem(SESSION_STORAGE_AMERICO_OBJECT_KEY,JSON.stringify(jsonRes.mctQuoterData)) : null;
            navigate(`/quote/term-life-insurance/loan-protector`);
          }
          else{
            sessionStorage.setItem(SESSION_STORAGE_COVR_FULLUW_KEY, data.appData);
            navigate(`/quote/term-life-insurance/multi-carrier-term/`);
          }
        } else {
          //setMessage('No progress was found.');
        }
        //setLoading(false);
      });
  }

  return <Row className="policy">
    <Col xs={6} lg={2} md={2} className="order-1" >
      <img className="img-fluid" src="/logos/covr-logo.svg" alt="covr-logo" />
    </Col>
    <Col xs={6} lg={2} md={3} className="order-2 order-lg-3 priceAmount order-md-3">

    </Col>
    <Col xs={12} lg={3} md={3} className="order-3 order-lg-2 order-md-2 carrierTerm">
      <p className="carrierProduct">Term Application</p> {props.inProgressItem.createdDate}
    </Col>
    <Col xs={6} lg={3} md={2} className="order-4">
      <p className="activity-status">Application Progress</p>
      <CommonLinearProgress 
        value={props.inProgressItem.progressPercent}
        barColor="#24A81B" 
      />
    </Col>
    <Col xs={6} lg={2} md={2} className="order-5 btnContinue">
      <Button onClick={() => retrieveProgress(props.inProgressItem.consumerApplicationId)} variant="contained" color="primary">
        Continue
      </Button>
    </Col>
  </Row>
}
